//--------------- IMPORTAÇÕES ---------------//
import { formatterDateDayMonth } from "../../../shared/utils";




//--------------- EXPORTAÇÃO DA PÁGINA ORDERBUMP RELATÓRIO ---------------//
export default function ContainerCustomTooltip({ active, payload }) {



    //--------------- RETORNO CONDICIONAL DA PÁGINA ORDERBUMP RELATÓRIO ---------------//
    return (
        <>
            {!active || !payload || payload.length === 0
                ? null
                :
                <>
                    <div className="bg-surface-2 p-2 rounded text-sm border border-white/[0.12]">
                        <div>Dia: {formatterDateDayMonth(payload[0].payload.dia)}</div>
                        <div>ID Produto: {payload[0].payload.id_produto_hotmart}</div>
                        <div>Quantidade: {payload[0].payload.quantidade}</div>
                    </div>
                </>
            }
        </>
    );
}
